export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no, email=no, address=no"},{"name":"google-site-verification","content":"wc87uOln8fGQvQS0GElgel2FX-it2trrU_Iz6WkU3oU"},{"hid":"description","name":"description","content":"株式会社ラジコードは、東京都にオフィスをかまえ、Webシステム開発・IT技術コンサルティング・新規サービス開発・既存サービス改善を行っています。クライアントとチームとなって成長し続ける開発体勢を月額定額制で提供しています。"},{"hid":"keywords","name":"keywords","content":"ラジコード,システム開発,WEB制作,IT技術コンサルティング,アジャイル,月額定額制"},{"hid":"og:site_name","property":"og:site_name","content":"株式会社ラジコード"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https://radicode.co.jp"},{"hid":"og:title","property":"og:title","content":"株式会社ラジコード"},{"hid":"og:description","property":"og:description","content":"株式会社ラジコードは、東京都にオフィスをかまえ、Webシステム開発・IT技術コンサルティング・新規サービス開発・既存サービス改善を行っています。クライアントとチームとなって成長し続ける開発体勢を月額定額制で提供しています。"},{"hid":"og:image","property":"og:image","content":"https://radicode.co.jp/ogp/ogp-tw.png"},{"name":"twitter:card","content":"summary_large_image"}],"style":[],"script":[{"src":"//polyfill.io/v2/polyfill.min.js?features=IntersectionObserver"}],"noscript":[],"htmlAttrs":{"lang":"ja","prefix":"og: http://ogp.me/ns#"},"titleTemplate":"%s | 株式会社ラジコード"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = true

export const devPagesDir = null

export const devRootDir = null